import { Battery0Bar, Battery1Bar, Battery4Bar, BatteryFull } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { ReactElement } from 'react';
import { BatteryState } from '../../apiRtk/be4feApi';
import { DORMAKABA_BATTERY_STATE } from '../../config/devices';
import { useGetGlobalInfo } from '../../hooks/useGetGlobalInfo';
import messages from './messages';

interface IDeviceDormakabaBatteryState {
  batteryState?: BatteryState;
}

function DeviceDormakabaBatteryState({ batteryState }: IDeviceDormakabaBatteryState) {
  const { formatMessage } = useGetGlobalInfo();

  function getBatteryLevel(batteryState?: BatteryState): {
    color: 'success' | 'warning' | 'error' | 'secondary';
    icon?: ReactElement;
    label: string;
    variant?: 'outlined' | 'filled';
  } {
    switch (batteryState) {
      case DORMAKABA_BATTERY_STATE.EXCELLENT:
        return { color: 'success', icon: <BatteryFull />, label: formatMessage(messages.lockBatteryFull) };
      case DORMAKABA_BATTERY_STATE.GOOD:
        return { color: 'success', icon: <Battery4Bar />, label: formatMessage(messages.lockBatteryHigh) };
      case DORMAKABA_BATTERY_STATE.MEDIUM:
        return { color: 'warning', icon: <Battery4Bar />, label: formatMessage(messages.lockBatteryMedium) };
      case DORMAKABA_BATTERY_STATE.LOW:
        return {
          color: 'warning',
          icon: <Battery1Bar />,
          label: formatMessage(messages.lockBatteryLow),
          variant: 'filled',
        };
      case DORMAKABA_BATTERY_STATE.VERY_LOW:
      case DORMAKABA_BATTERY_STATE.CRITICAL:
        return {
          color: 'error',
          icon: <Battery0Bar />,
          label: formatMessage(messages.lockBatteryCritical),
          variant: 'filled',
        };
      default:
        return { color: 'secondary', icon: undefined, label: formatMessage(messages.lockBatteryUnknown) };
    }
  }

  const { color, icon, label, variant } = getBatteryLevel(batteryState);

  return <Chip variant={variant ?? 'outlined'} size="small" icon={icon} label={label} color={color} />;
}

export default DeviceDormakabaBatteryState;
